<div class="go">
    <img [src]="go.svg"/>
</div>
